module.exports = __webpack_public_path__ + "static/media/IconUserActive.45833351.svg";